import { extractSdkErrorDetail } from "@istari-frontend/shared";

/** A failed registry request, with the server's `detail` message when its response carried one. */
export class RegistryRequestError extends Error {
  readonly detail: string | undefined;

  constructor(detail: string | undefined, cause: unknown) {
    super(detail ?? "The registry request failed.", { cause });
    this.name = "RegistryRequestError";
    this.detail = detail;
  }
}

export async function withErrorDetail<T>(request: () => Promise<T>): Promise<T> {
  try {
    return await request();
  } catch (error) {
    throw new RegistryRequestError(await extractSdkErrorDetail(error).catch(() => undefined), error);
  }
}

export function errorDetail(error: unknown): string | undefined {
  return error instanceof RegistryRequestError ? error.detail : undefined;
}
